
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd, getFaqJsonLd, injectJsonLd } from "@/utils/seo";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class flywheel extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "绩效飞轮® | 让战略成为每个人的日常工作 - 光华赋能",
      description:
        "光华绩效飞轮®是一套让战略落地的绩效管理方法论与工具，通过战略解码、目标对齐、过程管理、绩效复盘的闭环，让战略成为每个人的日常工作，驱动企业持续增长。",
      keywords:
        "绩效飞轮,绩效管理,战略落地,战略解码,目标管理,OKR,KPI,绩效复盘,光华赋能",
      path: "/performance-flywheel",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "数字化" },
        { name: "绩效飞轮" }
      ],
      jsonLd: getServiceJsonLd({
        name: "绩效飞轮",
        description:
          "一套让战略落地的绩效管理方法论与工具，通过战略解码、目标对齐、过程管理、绩效复盘的闭环驱动企业增长。",
        category: "绩效管理方法论"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/ff7f2204f5ab03254b1fb553ced0d190.png";
  pic2 = "/img/5a90876859ffc33cf178d9854ac47928.png";
  pic3 = "/img/5fa2c1424e5517fa3ab5b354aef2314f.png";
  pic4 = "/img/59122153d5f0d2b247a1732208d4ac22.png";
  pic5 = "/img/e53d8cc1b3a33315db01b32b0a2f673f.png";
  pic6 = "/img/eb318bf19b32ebb9a916a740e9f872ff.png";
  pic7 = "/img/499ce5b75ba94ae2a08251d03f615d8a.png";
  List = [
    { title: "数字化", url: "" },
    { title: "绩效飞轮", url: "" }
  ];
  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "数字化方案陪跑，EPM企业绩效系统，绩效飞轮，ELP，微学，光华商学"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "专家，落地指导，规划，战略到执行，数字化转型方案，数字化，转型，数字化+，+数字化，数字化管理体系，业务转型，效率提升，持续增长，底层框架 ,全盘规划,从战略到执行全流程,过程,落地,问题,目标,调研,诊断,成果,复盘,赛道分析,企业位置,行业趋势,企业现状营收、盈利、规模、定位、生态位、战略控制点、价值主张,组织与人才,人才、组织盘点,结构、员工数,管理体系机制、制度、流程（尤其是业务主流程）、股权,差距分析,机会差距,业绩差距,三找,找差距、找不满、,找原因,梳理核心问题,对标对标杆,对历史数据,对BLM,目标共识,FCIL四个角度,企业培训,海量课程库，阶段目录，有序学习，要点检测，成果考核，加深理解，记忆实践，巧用关联，灵活使用，学，考，练，用，个人学习，缺乏体系，员工提升，管理层、电商、营销等不同团队缺乏专属课程资源，无法进行精准的专项培训，人才培养效率低下，因学习资源与培训体系不完善，导致关键岗位的能力成长缓慢，业务发展受到制约，人才培养的滞后，最终成为企业创新与增长步伐的瓶颈，实力名师，体系化学习，结构化知识体系，精品课，试听"
    );
    document.head.appendChild(metaTag2);
    // 注入 FAQPage JSON-LD
    injectJsonLd(
      "jsonld-faq",
      getFaqJsonLd([
        {
          question: "GTT绩效飞轮是什么？有哪些版本？",
          answer: "GTT绩效飞轮是光华数字化旗下的核心产品，定位为「企业数字化绩效全过程云管理平台」，由光华赋能创始人方永飞老师在BSC原理（平衡计分卡）、BLM（业务领先模型）和绩效飞轮原理基础上开发的数字化管理系统，软件以绩效增长为主线，驱动从战略到执行全流程的数字化管理，具备战略管理、目标管理、绩效管理、数据管理等综合管理功能，兼具科学、严谨、智能、灵活、精细的优点。四大软件特色：1.目标取代指标——一改传统绩效考核的缺点，丢掉层层指标，人人制定目标，避免员工为了完成指标而做无用功，让一切工作行为回归战略目标，以目标为基础的绩效管理采用自上而下+自下而上、BSC四大角度全面规划、人人制定目标月月做精进、重过程+重结果、激励性机制激励驱动的模式；2.管理取代考核——采取CPO+KPO的「CK模式」，兼顾过程与结果，既监管了员工的工作行为，也解决了非业务线员工难考核的问题，CPO关注过程管理，KPO关注结果考核，两者结合实现全面绩效管理；3.达成战略共识——通过BSC让战略与员工日常工作之间的鸿沟彻底消失，让战略成为每个人的日常工作，GTT绩效飞轮将企业战略目标层层解码到部门和个人，确保每个员工的日常工作都与企业战略对齐；4.绩效持续增长——企业→部门→员工三级绩效管理正向循环，形成良性的「飞轮效应」，企业绩效持续增长，通过目标设定、执行跟踪、绩效评估、反馈改进的闭环管理，驱动绩效持续提升。三个版本对比：绩效飞轮®（钉钉版/GTT版）——基础人事✓、绩效管理✓、知识管理（KM+ELN）✗、销售管理（CRM）（可选）✓、智能数据分析✓、管理对标评估✓、主线作业流程✗、BLM企业战略规划✗、基础应用配置与指导✓、专家顾问辅导落地✗、经营性财务✗，适合需要基础绩效管理数字化的中小企业，功能涵盖基础人事、绩效管理、销售管理、智能数据分析、管理对标评估，性价比高；BLM绩效飞轮®——基础人事✓、绩效管理✓、知识管理（KM+ELN）✓、销售管理（CRM）（可选）✓、智能数据分析✓、管理对标评估✓、主线作业流程✗、BLM企业战略规划✓、基础应用配置与指导✓、专家顾问辅导落地✓、经营性财务✗，适合需要战略管理+绩效管理一体化的中大型企业，在基础版上增加了知识管理、BLM企业战略规划、专家顾问辅导落地等功能，帮助企业将战略到执行全流程数字化；EPM绩效飞轮®——基础人事✓、绩效管理✓、知识管理（KM+ELN）✓、销售管理（CRM）（可选）✓、智能数据分析✓、管理对标评估✓、主线作业流程✓、BLM企业战略规划✓、基础应用配置与指导✓、专家顾问辅导落地✓、经营性财务✓，适合大型企业和集团企业的全面经营绩效管理，在BLM版基础上增加了主线作业流程和经营性财务功能，实现企业经营全流程的数字化管理。平台嵌入能力：绩效飞轮®全版本均可嵌入钉钉、企业微信、企业自有系统等平台，企业可根据自身使用习惯选择部署方式，无需切换平台即可使用绩效管理功能。"
        },
        {
          question: "绩效飞轮和传统绩效考核软件有什么区别？",
          answer: "GTT绩效飞轮与传统绩效考核软件有着本质区别，核心在于「绩效管理」而非「绩效考核」，是「目标驱动」而非「指标管控」，是「战略落地工具」而非「人事管理工具」。第一，目标取代指标vs层层指标分解。传统绩效考核软件的核心逻辑是「指标分解」，将公司KPI层层分解到部门和个人，员工为了完成指标而工作，容易导致「为了指标而做无用功」的现象，甚至出现员工为了达标而牺牲长期利益的行为。绩效飞轮采用「目标取代指标」的理念，人人制定目标，目标基于BSC四大角度（财务、客户、内部流程、学习与成长）全面规划，采用自上而下+自下而上的目标制定方式，让一切工作行为回归战略目标，避免指标导向的短视行为。第二，管理取代考核vs单纯结果考核。传统绩效考核软件侧重于「结果考核」，到期打分、排名、扣钱，是「事后算账」的模式，无法对员工工作过程进行有效管理，也难以解决非业务线员工（如行政、财务、HR等）难考核的问题。绩效飞轮采用「管理取代考核」的理念，采取CPO+KPO的「CK模式」，CPO关注过程管理，KPO关注结果考核，两者结合兼顾过程与结果，既监管了员工的工作行为，也解决了非业务线员工难考核的问题，实现「过程+结果」的全面绩效管理。第三，战略落地工具vs人事管理工具。传统绩效考核软件本质上是「人事管理工具」，主要服务于HR部门的绩效考核和薪酬核算工作，与企业战略脱节，战略与员工日常工作之间存在巨大鸿沟。绩效飞轮是「战略落地工具」，通过BSC平衡计分卡将企业战略目标层层解码到部门和个人，让战略成为每个人的日常工作，彻底消除战略与执行之间的鸿沟。企业→部门→员工三级绩效管理正向循环，形成良性的「飞轮效应」，驱动企业绩效持续增长。第四，科学经营方法论底座vs纯技术工具。传统绩效考核软件多为纯技术工具，缺乏管理方法论支撑，软件功能与企业管理实践脱节，企业买了软件但用不起来。绩效飞轮由光华赋能创始人方永飞老师在BSC原理、BLM业务领先模型和绩效飞轮原理基础上开发，背后是光华23年企业经营研究和20000+企业服务经验沉淀的科学经营™方法论，软件功能与管理方法论深度融合，企业不仅获得一个软件工具，更获得一套科学的绩效管理体系。第五，飞轮效应持续增长vs考核周期循环。传统绩效考核软件是「考核周期循环」模式，每季度或每年重复考核打分，绩效水平难以持续提升。绩效飞轮通过目标设定、执行跟踪、绩效评估、反馈改进的闭环管理，形成企业→部门→员工三级绩效管理的正向循环，每一轮循环都推动绩效水平提升，真正实现「绩效持续增长」的飞轮效应。第六，专家顾问辅导落地vs软件交付即结束。传统绩效考核软件厂商交付软件后即结束服务，企业能否用起来全靠自己。绩效飞轮的BLM版和EPM版提供专家顾问辅导落地服务，由光华专业顾问帮助企业梳理绩效管理体系、配置软件功能、培训员工使用、跟踪落地效果，确保软件真正用起来、出效果。"
        }
      ])
    );
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
